export default "__VITE_ASSET__CgenpHc6__"